// removed by extract-text-webpack-plugin


/*****************
 ** WEBPACK FOOTER
 ** ./src/modules/message/message.less
 ** module id = 44
 ** module chunks = 0
 **/